/* eslint no-empty: 0 */

export function setStoredValue(key, value) {
  if (typeof (Storage) === 'undefined') {
    return null;
  }

  try {
    window.sessionStorage.setItem(key, value);
  } catch (e) { } // Move on if fails for any reason. For now.

  return value;
}

export function getStoredValue(key) {
  if (typeof (Storage) === 'undefined') {
    return null;
  }

  return window.sessionStorage.getItem(key);
}

export function clearStoredValue(key) {
  if (typeof (Storage) === 'undefined') {
    return null;
  }

  const value = window.sessionStorage.getItem(key);
  window.sessionStorage.removeItem(key);
  return value;
}



// WEBPACK FOOTER //
// ./utils/storage.js